import { initializeGallery } from "Functions/lightgallery";
import { updateLazy } from "Functions/lazy";
import { initProductMarginsTooltip } from "Functions/tippy";

/**
 * This file is used to initialize javascript on dynamic elements in the DOM
 *
 * This will run when multiple times, so beware of multiple firing eventListeners
 *
 * When it will run?
 *  - when the page is loaded
 *  - every time when the variation is changed and elements are replaced
 */
export function initializeVariationsDynamicElements() {
    initializeGallery();
    updateLazy();
    initProductMarginsTooltip();
}

/**
 * For example, destroy lightGallery
 *
 * But this might be covered by garbage collection?
 * I'm not sure if this is necessary
 * https://www.reddit.com/r/learnjavascript/comments/14jykn4/comment/jpp0oli/
 */
export function beforeReplaceVariationsDynamicElements() {}

/**
 * This function is used to replace dynamic elements in the DOM
 *
 * You need to define the elements that you want to replace in the elements object
 */
export function replaceVariationsDynamicElements(elements) {
    if (!elements) {
        return;
    }

    beforeReplaceVariationsDynamicElements();

    for (const selector in elements) {
        const elementToReplace = document.querySelector(`[r-dynamic-element="${selector}"]`);

        if (!elementToReplace) {
            continue;
        }

        elementToReplace.outerHTML = elements[selector];
    }

    initializeVariationsDynamicElements();
}
